var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-col",
    _vm._b(
      {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["merchant:statistics:home:operating:data"],
            expression: "['merchant:statistics:home:operating:data']",
          },
        ],
      },
      "el-col",
      _vm.grid,
      false
    ),
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c("div", { staticClass: "header_title" }, [_vm._v("经营数据")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "nav_grid" },
          _vm._l(_vm.businessList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "nav_grid_item",
                on: {
                  click: function ($event) {
                    return _vm.navigatorTo(item.path)
                  },
                },
              },
              [
                _c("p", { staticClass: "num_data" }, [
                  _vm._v(_vm._s(item.num || 0)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "label" }, [_vm._v(_vm._s(item.title))]),
              ]
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }